import { Skeleton } from "@organizacaox/lai-design-system";

export function ShowcaseSkeleton() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-showcase-skeleton
      className="w-full min-w-0 motion-reduce:[&_[data-slot=skeleton]]:animate-none [&_[data-slot=skeleton]]:bg-foreground/10"
    >
      <span className="sr-only">Carregando vitrine…</span>
      <div aria-hidden="true" className="flex min-w-0 flex-col gap-10">
        <div
          data-showcase-skeleton-hero
          className="relative flex min-h-72 w-full items-end overflow-hidden rounded-2xl border bg-card sm:aspect-[16/6] sm:min-h-0"
        >
          <Skeleton className="absolute inset-0 size-full rounded-none opacity-30" />
          <div className="relative flex w-full max-w-xl flex-col gap-4 p-4 sm:p-8">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-8 w-4/5 sm:h-10" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </div>
            <Skeleton className="mt-2 h-10 w-36 rounded-md" />
          </div>
        </div>
        {[0, 1, 2].map((shelf) => (
          <div key={shelf} data-showcase-skeleton-shelf className="min-w-0 space-y-3">
            <div className="flex items-center justify-between gap-3">
              <Skeleton className="h-6 w-44 max-w-[60%]" />
              <div className="flex shrink-0 gap-2">
                <Skeleton variant="circle" className="size-8" />
                <Skeleton variant="circle" className="size-8" />
              </div>
            </div>
            <div className="overflow-hidden rounded-xl">
              <div className="-ml-3 flex">
                {[0, 1, 2].map((poster) => (
                  <div
                    key={poster}
                    className="min-w-0 shrink-0 basis-[94%] pl-3 sm:basis-[70%] lg:basis-1/3"
                  >
                    <div className="relative aspect-[16/10] min-h-48 overflow-hidden rounded-xl border bg-card">
                      <Skeleton className="absolute inset-0 size-full rounded-none opacity-30" />
                      <div className="absolute inset-x-4 bottom-4 flex flex-col gap-3">
                        <Skeleton className={`h-4 ${poster % 2 ? "w-2/3" : "w-4/5"}`} />
                        <Skeleton className="h-3 w-1/2" />
                        <Skeleton className="h-3 w-1/3" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
